import { Component } from '@angular/core';
@Component({
  selector: 'app-notfound',
  templateUrl: './app.notfound.component.html',
  styleUrls: ['./app.notfound.component.scss']
})
export class AppNotfoundComponent {
  constructor() {

  }
  async redirectToLogin() {
    const previousUrl = sessionStorage.getItem('previousUrl');
    if (previousUrl) {
      window.location.href = previousUrl;
    } else {
      window.location.href = '/login'; // Replace '/default' with the default page URL
    }
  }
}
